"use client";
import { Skeleton } from "@focal/ui-kit";
import { Heading } from "@focal/ui-kit";
import React, { ReactNode } from "react";

interface PageHeaderProps {
  title?: string;
  level?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  className?: string;
  /**
   * Right-hand slot, level with the title. For page-scoped links and actions
   * that belong to the whole page rather than to one list or tab inside it.
   */
  actions?: ReactNode;
  /** Inline beside the title, e.g. a "Beta" tag. */
  titleAdornment?: ReactNode;
}

export const PageHeader = ({
  title,
  level = "h5",
  className,
  actions,
  titleAdornment,
}: PageHeaderProps) => {
  return (
    <div className="flex justify-between items-center w-full pb-4 pt-0 lg:pt-4 pl-10 lg:pl-0">
      {title ? (
        <div className="flex min-w-0 items-center gap-2">
          <Heading
            as={level}
            level={level}
            spacing="none"
            className={className}
          >
            {title}
          </Heading>
          {titleAdornment}
        </div>
      ) : (
        <Skeleton className="h-6 w-[200px]" />
      )}
      {actions ? (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
};
